import { useEffect } from "react";

const useFocusInputOnMount = (inputRef: React.RefObject<HTMLInputElement>) => {
  useEffect(() => {
    inputRef.current?.focus();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useFocusInputOnMount;